import { useEffect } from "react";
import Lenis from "lenis";

export const useSmoothScroll = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.4,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);

    // Anchor link handling
    const handler = (e) => {
      const a = e.target.closest("a[href^='#']");
      if (!a) return;
      const href = a.getAttribute("href");
      if (!href || href === "#") return;
      const el = document.querySelector(href);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -60 });
    };
    document.addEventListener("click", handler);

    return () => {
      document.removeEventListener("click", handler);
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, [enabled]);
};
